import { QueryCache, QueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { redirectToAuth } from "src/hooks/defaultOptions";

declare global {
	interface Window {
		__QUERY_CLIENT__?: QueryClient;
	}
}

// Jedna instancja na okno (przezywa HMR) — wspolna dla panelu i admina
if (!window.__QUERY_CLIENT__) {
	window.__QUERY_CLIENT__ = new QueryClient({
		queryCache: new QueryCache({
			onError: (error, query) => {
				if (
					query.meta?.redirectOn401 &&
					(error as AxiosError)?.response?.status === 401
				) {
					redirectToAuth();
				}
			},
		}),
		defaultOptions: {
			queries: {
				gcTime: 3 * 60 * 1000,
			},
		},
	});
}

export const queryClient = window.__QUERY_CLIENT__;

const persistentKeys = [
	"app-config",
	"user-info",
	"notifications-count",
	"unresolved-pes-notifications-count",
	"cooperations",
];

export function clearTransientCache() {
	queryClient
		.getQueryCache()
		.getAll()
		.forEach((query) => {
			const key = query.queryKey;
			const rootKey = Array.isArray(key) ? key[0] : key;
			if (!persistentKeys.includes(rootKey as string)) {
				queryClient.removeQueries({ queryKey: key });
			}
		});
}
